import { MessageDefinitionForm } from "./parts/message-definition-form";
import { BaseScreen } from "../../components/base-screen";

export const MessageDefinitionEditScreen = () => {
	return (
		<BaseScreen>
			<MessageDefinitionForm />
		</BaseScreen>
	);
};
